import { render, staticRenderFns } from "./SupportTypeLegend.vue?vue&type=template&id=c0f96860&scoped=true"
var script = {}
import style0 from "./SupportTypeLegend.vue?vue&type=style&index=0&id=c0f96860&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f96860",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0f96860')) {
      api.createRecord('c0f96860', component.options)
    } else {
      api.reload('c0f96860', component.options)
    }
    module.hot.accept("./SupportTypeLegend.vue?vue&type=template&id=c0f96860&scoped=true", function () {
      api.rerender('c0f96860', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/visit-registration-calendar/components/SupportTypeLegend.vue"
export default component.exports